import apiClient from '../client/api-client'
import axios from 'axios'
const unifiedSearchService = 'unified-search-service'
const request = 'request'
import { baseURL } from 'config'

export default {
  /**
   * Fetches timeline data for a user based on type, patient uuid and sort
   * @return {Promise}      Returns an array of medical/non-medical data for a user by type
   */
  async fetchTimelineData(payload) {
    if (payload.token) {
      let headers = ''
      try {
        headers = {
          Authorization: `Bearer ${payload.token}`,
          'Content-Type': 'application/json'
        }
        const { data } = await axios.get(`${baseURL}/${unifiedSearchService}/${request}`, {
          headers: headers,
          params: {
            type: payload.type,
            patientId: payload.patientId,
            sort: payload.sort,
            searchTerm: payload.searchTerm,
            limit: payload.limit,
            diseaseCard: payload.diseaseCard,
            grantor: payload.grantor
          }
        })
        return data
      } catch (err) {
        throw new Error(err)
      }
    } else {
      try {
        const { data } = await apiClient.get(`${unifiedSearchService}/${request}`, {
          params: {
            type: payload.type,
            patientId: payload.patientId,
            sort: payload.sort,
            searchTerm: payload.searchTerm,
            limit: payload.limit,
            diseaseCard: payload.diseaseCard
          }
        })
        return data
      } catch (err) {
        throw new Error(err)
      }
    }
  }
}
